/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  collapsed: 'is-collapsed',
  desktop: 'is-desktop',
  disabled: 'is-disabled',
  error: 'is-error',
  focusStyles: 'show-focus-styles',
  hidden: 'is-hidden',
  loading: 'is-loading',
  minimised: 'is-minimised',
  mobile: 'is-mobile',
  open: 'is-open',
  updating: 'is-updating',
}
